/*============================================================================
  Shipping Protection — Auto-add + custom toggle in UpCart Shadow DOM
  - Auto-adds SP when customer adds a product
  - Hides SP from UpCart's regular cart items
  - Hides UpCart's native addon toggle (fixed near checkout)
  - Shows our own toggle box after "Others also bought" (in scroll area)
==============================================================================*/
(function() {
  var cfg = window.__SP_CONFIG || {};
  var SP_VARIANT_ID = Number(cfg.variantId || 0);
  if (!SP_VARIANT_ID) return;

  /* ── Hide SP from UpCart's internal cart (fixes item count + progress bar) */
  var origModifyCart = window.upcartModifyCart;
  window.upcartModifyCart = function(cart) {
    if (origModifyCart) cart = origModifyCart(cart);
    if (cart && cart.items) {
      cart.items = cart.items.filter(function(item) {
        return item.variant_id != SP_VARIANT_ID;
      });
      cart.item_count = cart.items.length;
    }
    return cart;
  };

  /* ── Cart helpers ─────────────────────────────────────────────────────── */
  var origFetch = window.fetch;

  function getCart() {
    return origFetch.call(window, '/cart.js').then(function(r) { return r.json(); });
  }

  function addProtection() {
    return origFetch.call(window, '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: SP_VARIANT_ID, quantity: 1, properties: { '_protection': 'true' } }]
      })
    }).then(function(r) { return r.json(); }).then(function(data) {
      if (window.upcartRefreshCart) window.upcartRefreshCart();
      return data;
    }).catch(function(e) { console.warn('SP: addProtection failed', e); });
  }

  function removeProtection(lineKey) {
    return origFetch.call(window, '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    }).then(function(r) { return r.json(); }).then(function(cart) {
      if (window.upcartRefreshCart) window.upcartRefreshCart();
      return cart;
    }).catch(function(e) { console.warn('SP: removeProtection failed', e); });
  }

  /* ── Declined flag ────────────────────────────────────────────────────── */
  function isDeclined()  { return sessionStorage.getItem('sp_declined') === '1'; }
  function setDeclined() { sessionStorage.setItem('sp_declined', '1'); }
  function clearDeclined() { sessionStorage.removeItem('sp_declined'); }

  /* ── Core sync ────────────────────────────────────────────────────────── */
  var syncing = false;
  function syncProtection(callback) {
    if (syncing) return;
    syncing = true;
    getCart().then(function(cart) {
      var sp = null;
      var others = [];
      cart.items.forEach(function(item) {
        if (item.variant_id == SP_VARIANT_ID) sp = item;
        else others.push(item);
      });

      if (others.length === 0 && !sp) {
        clearDeclined(); syncing = false; if (callback) callback(); return;
      }
      if (others.length === 0 && sp) {
        clearDeclined();
        removeProtection(sp.key).then(function() { syncing = false; if (callback) callback(); });
        return;
      }
      if (others.length > 0 && !sp && !isDeclined()) {
        addProtection().then(function() { syncing = false; if (callback) callback(); });
        return;
      }
      if (sp && sp.quantity > 1) {
        origFetch.call(window, '/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: sp.key, quantity: 1 })
        }).then(function() {
          if (window.upcartRefreshCart) window.upcartRefreshCart();
          syncing = false; if (callback) callback();
        });
        return;
      }
      syncing = false;
      if (callback) callback();
    }).catch(function() { syncing = false; });
  }

  /* ── Filter SP from cart responses so UpCart never counts it ──────────── */
  function filterSPFromCart(cart) {
    if (!cart || !cart.items) return cart;
    cart.items = cart.items.filter(function(item) {
      return item.variant_id != SP_VARIANT_ID;
    });
    cart.item_count = cart.items.length;
    return cart;
  }

  /* ── Intercept fetch to detect cart changes + filter SP from responses ── */
  window.fetch = function() {
    var url = arguments[0];
    var opts = arguments[1] || {};
    var isCartJs = (typeof url === 'string') && url.indexOf('/cart.js') !== -1;
    var isCartAdd = (typeof url === 'string') && url.indexOf('/cart/add') !== -1;
    var isCartChange = (typeof url === 'string') && url.indexOf('/cart/change') !== -1;

    // Detect SP removal by UpCart or user
    if (isCartChange && !syncing && opts.body) {
      try {
        var body = typeof opts.body === 'string' ? JSON.parse(opts.body) : opts.body;
        if (body.quantity === 0 || body.quantity === '0') {
          getCart().then(function(cart) {
            var sp = cart.items.find(function(i) { return i.variant_id == SP_VARIANT_ID; });
            if (sp && (body.id === sp.key || body.id == SP_VARIANT_ID)) {
              setDeclined();
            }
          });
        }
      } catch(e) {}
    }

    var result = origFetch.apply(this, arguments);

    // Filter SP out of /cart.js responses so UpCart's rewards/progress bar
    // never counts SP as an item. total_price is kept intact (includes SP).
    if (isCartJs) {
      result = result.then(function(response) {
        return response.clone().json().then(function(cart) {
          filterSPFromCart(cart);
          return new Response(JSON.stringify(cart), {
            status: response.status,
            statusText: response.statusText,
            headers: { 'Content-Type': 'application/json' }
          });
        }).catch(function() { return response; });
      });
    }

    if (isCartAdd && !syncing) {
      result.then(function() {
        setTimeout(function() { syncProtection(); }, 500);
      });
    }

    return result;
  };

  /* ── Also intercept XMLHttpRequest ────────────────────────────────────── */
  var origXHROpen = XMLHttpRequest.prototype.open;
  var origXHRSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function(method, url) {
    this._spUrl = url;
    return origXHROpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function(body) {
    var url = this._spUrl || '';
    if (url.indexOf('/cart/add') !== -1 && !syncing) {
      this.addEventListener('load', function() {
        setTimeout(function() { syncProtection(); }, 500);
      });
    }
    return origXHRSend.apply(this, arguments);
  };

  /* ── Shadow DOM helpers ───────────────────────────────────────────────── */
  function getRoot() {
    var el = document.getElementById('upCart');
    return el ? (el.shadowRoot || el) : null;
  }

  /* ── Hide SP from UpCart's regular cart item list ──────────────────────── */
  function hideSPLineItem() {
    var root = getRoot();
    if (!root) return;
    var items = root.querySelectorAll('.upcart-product-item');
    for (var i = 0; i < items.length; i++) {
      if (items[i].textContent.indexOf('Shipping Protection') !== -1) {
        items[i].style.setProperty('display', 'none', 'important');
      }
    }
  }

  /* ── Hide UpCart's native addon toggle ──────────────────────────────── */
  function hideUpCartAddon() {
    var root = getRoot();
    if (!root) return;

    // Strategy: walk direct children of .upcart-cart-body AND the entire
    // shadow root for small, leaf-level containers that are the native addon.
    // The native addon is a small section containing ONLY "Shipping Protection"
    // text + a toggle + price. It does NOT contain cart items, upsells, or checkout.

    // 1. Check direct children of .upcart-cart-body
    var body = root.querySelector('.upcart-cart-body');
    if (body) {
      var children = body.children;
      for (var i = 0; i < children.length; i++) {
        var child = children[i];
        if (child.id === 'sp-box') continue;
        if (child.id === 'sp-styles') continue;
        if (child.classList.contains('upcart-products-section')) continue;

        var txt = child.textContent || '';
        if (txt.indexOf('Shipping Protection') !== -1 &&
            txt.indexOf('Priority Handling') === -1 &&
            txt.indexOf('Others also bought') === -1 &&
            txt.indexOf('Checkout') === -1) {
          child.style.setProperty('display', 'none', 'important');
        }
      }
    }

    // 2. Also check elements outside .upcart-cart-body (footer/checkout area)
    //    Look for the specific UpCart addon class pattern
    var addonEls = root.querySelectorAll('[class*="addon"], [class*="Addon"], [class*="shipping-protection"], [class*="shippingProtection"]');
    for (var j = 0; j < addonEls.length; j++) {
      var el = addonEls[j];
      if (el.id === 'sp-box') continue;
      var elTxt = el.textContent || '';
      if (elTxt.indexOf('Shipping Protection') !== -1 &&
          elTxt.indexOf('Priority Handling') === -1) {
        el.style.setProperty('display', 'none', 'important');
      }
    }
  }

  /* ── Our custom SP box ────────────────────────────────────────────────── */
  var SP_PRICE = cfg.price || '€3.95';
  var SP_TITLE = cfg.title || 'Priority Handling &amp; Shipping Protection';
  var SP_DESC = cfg.desc || 'Full replacement if your order is lost, stolen, or damaged in transit.';
  var SP_FINE = cfg.fine || 'Claims within 30 days of delivery.';
  var SP_IMG = cfg.img || '';
  var spBoxHTML = '<div id="sp-box" style="background:#f8f9fa;border:1px solid #e5e7eb;border-radius:8px;padding:12px 14px;margin:8px 16px;">' +
    '<div style="display:flex;align-items:flex-start;justify-content:space-between;gap:12px;">' +
      '<div style="display:flex;gap:10px;flex:1;">' +
        '<div style="flex-shrink:0;margin-top:2px;">' +
          '<img src="' + SP_IMG + '" alt="" width="24" height="24" style="display:block;">' +
        '</div>' +
        '<div>' +
          '<div style="font-size:13px;font-weight:600;color:#111;line-height:1.3;">' + SP_TITLE + '</div>' +
          '<div style="font-size:11px;color:#555;line-height:1.4;margin-top:2px;">' + SP_DESC + '</div>' +
          '<div style="font-size:10px;color:#999;margin-top:3px;">' + SP_FINE + '</div>' +
        '</div>' +
      '</div>' +
      '<div style="display:flex;flex-direction:column;align-items:flex-end;gap:6px;flex-shrink:0;">' +
        '<span id="sp-price-display" style="font-size:13px;font-weight:600;color:#111;">' + SP_PRICE + '</span>' +
        '<label style="position:relative;display:inline-block;width:40px;height:22px;cursor:pointer;">' +
          '<input type="checkbox" id="sp-toggle" style="opacity:0;width:0;height:0;">' +
          '<span id="sp-slider" style="position:absolute;cursor:pointer;top:0;left:0;right:0;bottom:0;background:#ccc;border-radius:22px;transition:.3s;"></span>' +
        '</label>' +
      '</div>' +
    '</div>' +
  '</div>';

  /* ── Inject SP box after "Others also bought" in Shadow DOM ──────────── */
  function injectSPBox() {
    var root = getRoot();
    if (!root) return;
    if (root.querySelector('#sp-box')) return;

    var body = root.querySelector('.upcart-cart-body');
    if (!body) return;

    // Inject slider CSS into shadow root
    if (!root.querySelector('#sp-styles')) {
      var style = document.createElement('style');
      style.id = 'sp-styles';
      style.textContent =
        '#sp-slider:before{content:"";position:absolute;height:16px;width:16px;left:3px;bottom:3px;background:white;border-radius:50%;transition:.3s;}' +
        '#sp-toggle:checked+#sp-slider{background:#2563eb !important;}' +
        '#sp-toggle:checked+#sp-slider:before{transform:translateX(18px);}' +
        '#sp-toggle:not(:checked)+#sp-slider{background:#ccc !important;}' +
        '#sp-toggle:not(:checked)+#sp-slider:before{transform:translateX(0);}';
      body.appendChild(style);
    }

    // Find "Others also bought" section and insert after it
    var insertBefore = null;
    var children = body.children;
    for (var i = 0; i < children.length; i++) {
      var txt = children[i].textContent || '';
      if (txt.indexOf('Others also bought') !== -1 || txt.indexOf('You may also like') !== -1 || txt.indexOf('Andere kauften auch') !== -1) {
        insertBefore = children[i].nextElementSibling;
        break;
      }
    }

    // Fallback: insert before checkout area
    if (!insertBefore) {
      for (var j = children.length - 1; j >= 0; j--) {
        if ((children[j].textContent || '').indexOf('Checkout') !== -1) {
          insertBefore = children[j];
          break;
        }
      }
    }

    var div = document.createElement('div');
    div.innerHTML = spBoxHTML;
    body.insertBefore(div.firstChild, insertBefore || null);
    bindToggle();
    var _spT = root.querySelector('#sp-toggle'); if (_spT) _spT.checked = !isDeclined();
  }

  /* ── Toggle event handler ─────────────────────────────────────────────── */
  function bindToggle() {
    var root = getRoot();
    if (!root) return;
    var toggle = root.querySelector('#sp-toggle');
    if (!toggle) return;

    toggle.addEventListener('change', function() {
      if (this.checked) {
        clearDeclined();
        syncing = true;
        addProtection().then(function() { syncing = false; }).catch(function() { syncing = false; });
      } else {
        setDeclined();
        syncing = true;
        getCart().then(function(cart) {
          var sp = cart.items.find(function(i) { return i.variant_id == SP_VARIANT_ID; });
          if (sp) removeProtection(sp.key).then(function() { syncing = false; }).catch(function() { syncing = false; });
          else syncing = false;
        }).catch(function() { syncing = false; });
      }
    });
  }

  /* ── Format cart price (cents) with currency symbol ───────────────────── */
  var currencySymbols = { USD:'$', AUD:'$', CAD:'$', EUR:'€', GBP:'£', CHF:'CHF ' };
  function formatCartPrice(cents, currency) {
    var sym = currencySymbols[currency] || (currency + ' ');
    return sym + (cents / 100).toFixed(2);
  }

  /* ── Update SP box state ──────────────────────────────────────────────── */
  function updateSPBox() {
    var root = getRoot();
    if (!root) return;

    getCart().then(function(cart) {
      var sp = cart.items.find(function(i) { return i.variant_id == SP_VARIANT_ID; });
      var others = cart.items.filter(function(i) { return i.variant_id != SP_VARIANT_ID; });

      var box = root.querySelector('#sp-box');
      if (others.length === 0) {
        if (box) box.style.display = 'none';
        return;
      }

      if (!box) {
        injectSPBox();
        box = root.querySelector('#sp-box');
      }
      if (box) {
        box.style.display = 'block';
        var toggle = root.querySelector('#sp-toggle');
        if (toggle) toggle.checked = !!sp || !isDeclined();
        // Update displayed price with actual cart price (market-converted)
        if (sp && sp.price) {
          var priceEl = root.querySelector('#sp-price-display');
          if (priceEl) priceEl.textContent = formatCartPrice(sp.price, cart.currency);
        }
      }
    });
  }

  /* ── Cap SP quantity to 1 (in case UpCart's addon also adds it) ──────── */
  var capping = false;
  function capSPQuantity() {
    if (capping || syncing) return;
    capping = true;
    getCart().then(function(cart) {
      var sp = cart.items.find(function(i) { return i.variant_id == SP_VARIANT_ID; });
      if (sp && sp.quantity > 1) {
        origFetch.call(window, '/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: sp.key, quantity: 1 })
        }).then(function() {
          if (window.upcartRefreshCart) window.upcartRefreshCart();
          capping = false;
        });
      } else {
        capping = false;
      }
    }).catch(function() { capping = false; });
  }

  /* ── Enforce: hide items + addon, show our box ────────────────────────── */
  function enforce() {
    hideSPLineItem();
    hideUpCartAddon();
    capSPQuantity();
    var root = getRoot();
    if (!root) return;
    if (!root.querySelector('#sp-box')) {
      injectSPBox();
      updateSPBox();
    }
  }

  /* ── Init ──────────────────────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { syncProtection(); });
  } else {
    syncProtection();
  }

  // Use UpCart's event API to detect cart changes (more reliable than fetch interception)
  function hookUpCartEvents() {
    if (window.upcartSubscribeAddedToCart) {
      window.upcartSubscribeAddedToCart(function() {
        setTimeout(function() { syncProtection(function() { updateSPBox(); }); }, 500);
      });
    }
    if (window.upcartSubscribeCartUpdated) {
      window.upcartSubscribeCartUpdated(function() {
        setTimeout(function() { updateSPBox(); }, 500);
      });
    }
    if (window.upcartSubscribeCartOpened) {
      window.upcartSubscribeCartOpened(function() {
        setTimeout(function() { syncProtection(function() { updateSPBox(); }); }, 300);
      });
    }
  }

  // UpCart may not be initialized yet — retry until available
  if (window.__upcartInitialized) {
    hookUpCartEvents();
  } else {
    var hookRetries = 0;
    var hookInterval = setInterval(function() {
      hookRetries++;
      if (window.__upcartInitialized || window.upcartSubscribeAddedToCart || hookRetries > 30) {
        clearInterval(hookInterval);
        hookUpCartEvents();
      }
    }, 500);
  }

  // Watch UpCart shadow root for re-renders
  var enforceTimer = null;
  var observerAttached = false;
  setInterval(function() {
    var root = getRoot();
    if (!root) return;
    var body = root.querySelector('.upcart-cart-body');
    if (!body) return;

    enforce();

    if (!observerAttached) {
      observerAttached = true;
      var obs = new MutationObserver(function() {
        clearTimeout(enforceTimer);
        enforceTimer = setTimeout(enforce, 200);
      });
      obs.observe(root, { childList: true, subtree: true });
    }
  }, 800);

})();
